module.exports = __webpack_public_path__ + "img/history-track.95f4f93d.svg";